import publicRuntimeConfig from "@FRAMEWORK/config/public";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface GoodsCompare {
	goodsCd: string;
	goodsNm: string;
	minAdtPrice: number;
	maxAdtPrice: number;
	minChdPrice: number;
	maxChdPrice: number;
	minInfPrice: number;
	maxInfPrice: number;
	evNightNm: string;
	prdExpl: string;
	outfDate: string;
	outeDate: string;
	vcityInfo: string;
	webLinkUrl: string;
}

interface GoodsCalendar {
	goodsCd: string;
	evCd: string;
	evStartDt: string;
	singleTypeCd: string;
	dspSid: string;
	calStatus: string /* A: 예약가능, W: 예약대기, C: 예약마감 */;
}

interface GoodsCompareType {
	compareList: Array<GoodsCompare>;
	calendarList: Array<GoodsCalendar>;
}

/** ```
 * 상품 비교하기
 *   `/pkg/goods/compare
 * parameter
 *   `compareGoodsCd` 상품코드 ex) "ATP1127,ATP1164"
 * ```*/
const key = "useGoodsCompare";
const getPath = (): string | null => `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/goods/compare`;

/** ```
 * 상품 비교하기
 *   `/pkg/goods/compare
 * parameter
 *   `compareGoodsCd` 상품코드 ex) "ATP1127,ATP1164"
 * ```*/
const goodsCompareAsync = async (compareGoodsCd: string) => {
	const result = await useConfigureAxios(getPath(), {method: "POST", data: {compareGoodsCd}});
	return result;
};

/** ```
 * 상품 비교하기
 *   `/pkg/goods/compare
 * parameter
 *   `compareGoodsCd` 상품코드 ex) "ATP1127,ATP1164"
 * ```*/
const useGoodsCompare = (
	compareGoodsCd: string,
	options?: Partial<UseQueryOptions<Response<GoodsCompareType>, Error>>,
) =>
	useQuery({
		queryKey: [key, getPath()],
		queryFn: () => useConfigureAxios({url: getPath(), method: "POST", data: {compareGoodsCd}}).then(r => r.data),
		...options,
	});

export default useGoodsCompare;
export {getPath, key, goodsCompareAsync};
export type {GoodsCompareType, GoodsCompare, GoodsCalendar};
